import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/statistics")({
  beforeLoad: () => {
    throw redirect({ to: "/analytics" });
  },
  component: () => null,
});
